import "./App.css"
import { Route, Routes } from "react-router"
import { Toaster } from "react-hot-toast"
import { Suspense } from "react"
import { Loader } from "./components/Loader/loader"
import LaunchNewAdPage from "./pages/LaunchNewAdPage/LaunchNewAdPage"
import CreativeSelectionPage from "./pages/CreativeSelectionPage/CreativeSelectionPage"
import LoginPage from "./pages/LoginPage/LoginPage"
import GroupCreativesPage from "./pages/GroupCreativesPage/GroupCreativesPage"
import MapLandingPage from "./pages/MapLandingPage/MapLandingPage"
import AdCopyPage from "./pages/AdCopyPage/AdCopyPage"
import ReviewDefaultValues from "./pages/ReviewDefaultValues/ReviewDefaultValues"
import ReviewDefaultValuesAP from "./pages/ReviewDefaultValuesAP/ReviewDefaultValuesAP"
import EventLogProgress from "./pages/EventLogProgress/EventLogProgress"
import AdsSummary from "./pages/AdsSummary/AdsSummary"
import ProtectedRoute from "./components/ProtectedRoute"
import AdsPostingProgress from "./pages/AdsPostingProgress/AdsPostingProgress"
import VerifyMetaAuthPage from "./pages/VerifyMetaAuthPage/VerifyMetaAuthPage"
import AdvancedAdsetMappingPage from "./pages/AdvancedAdsetMapping/AdvancedAdsetMappingPage"
// import SettingsPage from './pages/SettingsPage/SettingsPage';
import QuickLaunchAds from "./pages/QuickLaunchAds/QuickLaunchAds"
import LaunchHistory from "./pages/LaunchHistory/LaunchHistory"
import Sidebar from "@components/Sidebar/Sidebar"
import { useSelector, shallowEqual } from "react-redux"
import React, { useMemo } from "react"
import { useLocation } from "react-router-dom"
import useUser from "./hooks/useUser"
import AdTemplates from "./pages/AdTemplates/AdTemplates"
import Settings from "./pages/SettingsPage/NewSettings"
import SheetAdLauncher from "./pages/SheetAdLauncher/SheetAdLauncher"
import SheetLaunchAds from "./pages/SheetAdLauncher/SheetLaunchAds"
import QuickLaunchAdsDeprecation from "./pages/QuickLaunchAds/QuickLaunchAdsDeprecation"
import SettingsDeprecation from "./pages/SettingsPage/SettingsDeprecation"
import LaunchHistoryDeprecation from "./pages/LaunchHistory/LaunchHistoryDeprecation"
import AdTemplatesDeprecation from "./pages/AdTemplates/AdTemplatesDeprecation"

function App() {
  const { handleGetUserById } = useUser()
  // const [currentUserId, setCurrentUserId] = React.useState(localStorage.getItem('userId'));

  // Check for user ID changes
  // React.useEffect(() => {
  //   const checkUserIdChange = () => {
  //     const newUserId = localStorage.getItem('userId');
  //     if (newUserId !== currentUserId) {
  //       setCurrentUserId(newUserId);
  //       if (newUserId) {
  //         handleGetUserById();
  //       }
  //     }
  //   };

  //   // Check on mount
  //   checkUserIdChange();

  //   // Set up event listener for storage changes
  //   window.addEventListener('storage', checkUserIdChange);

  //   // Custom event for logout/login actions
  //   window.addEventListener('userStateChange', checkUserIdChange);

  //   return () => {
  //     window.removeEventListener('storage', checkUserIdChange);
  //     window.removeEventListener('userStateChange', checkUserIdChange);
  //   };
  // }, [currentUserId, handleGetUserById]);

  React.useEffect(() => {
    const userId = localStorage.getItem("userId")
    if (userId) {
      handleGetUserById()
    }
  }, [])

  const user = useSelector((state) => state.user.user, shallowEqual)

  // Only show Sidebar for QuickLaunchAds and LaunchHistory routes
  const location = useLocation()
  const showSidebar = [
    "/quick-launch-ads",
    "/launch-history",
    "/sheet-launch-ads",
    "/ad-templates",
    "/settings",
    "/sheet-ad-launcher",
  ].includes(location.pathname)

  // const memoSidebar = useMemo(() => {
  //   if (showSidebar && user) {
  //     return <Sidebar user={user} activePath={location.pathname} />;
  //   }
  //   return null;
  // }, [showSidebar, user, location.pathname]);
  const memoSidebar = useMemo(
    () =>
      showSidebar ? (
        <Sidebar user={user} activePath={location.pathname} />
      ) : null,
    [showSidebar, user, location.pathname]
  )

  return (
    <div>
      <Toaster toastOptions={{ style: { zIndex: 3000 } }} />
      <div style={{ display: "flex", minHeight: "100vh" }}>
        {/* Sidebar */}
        {showSidebar && (
          <ProtectedRoute>
            <div style={{ width: 256, minWidth: 256, zIndex: 50 }}>
              {memoSidebar}
            </div>
          </ProtectedRoute>
        )}
        {/* Main Content */}
        <div style={{ flex: 1 }}>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route
                path="/launch-new-ad"
                element={
                  <ProtectedRoute>
                    <LaunchNewAdPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/quick-launch-ads"
                element={
                  <ProtectedRoute>
                    <QuickLaunchAdsDeprecation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sheet-ad-launcher"
                element={
                  <ProtectedRoute>
                    <SheetAdLauncher />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path="/sheet-launch-ads"
                element={
                  <ProtectedRoute>
                    <SheetLaunchAds />
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="/ad-templates"
                element={
                  <ProtectedRoute>
                    {/* <AdTemplates /> */}
                    <AdTemplatesDeprecation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/launch-history"
                element={
                  <ProtectedRoute>
                    {/* <LaunchHistory /> */}
                    <LaunchHistoryDeprecation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <SettingsDeprecation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/creative-selection"
                element={
                  <ProtectedRoute>
                    <CreativeSelectionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/group-creatives"
                element={
                  <ProtectedRoute>
                    <GroupCreativesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/map-landing-page"
                element={
                  <ProtectedRoute>
                    <MapLandingPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ad-copy"
                element={
                  <ProtectedRoute>
                    <AdCopyPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/review-default-values"
                element={
                  <ProtectedRoute>
                    <ReviewDefaultValues />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/review-default-values-ap"
                element={
                  <ProtectedRoute>
                    <ReviewDefaultValuesAP />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/event-log-progress"
                element={
                  <ProtectedRoute>
                    <EventLogProgress />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/ads-summary"
                element={
                  <ProtectedRoute>
                    <AdsSummary />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/ads-progress"
                element={
                  <ProtectedRoute>
                    <AdsPostingProgress />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/advanced-adset-mapping"
                element={
                  <ProtectedRoute>
                    <AdvancedAdsetMappingPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/verify-meta-auth"
                element={<VerifyMetaAuthPage />}
              />
            </Routes>
          </Suspense>
        </div>
      </div>
    </div>
  )
}

export default App
